import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Events, OnClick } from "../../../library-js/dom-tools/EventListeners";
import { Func } from "../../../library-js/tools/TypeUtilities";
import { InspectorField } from "../fields/InspectorField";
import { InspectorCreationInfo } from "../InspectorCreationInfo";
import { CallbackButtonField } from "./CallbackButtonField";


export class CallbackButton
{
  protected _callback:Func<void>;

  setCallback( cb:Func<void> = null )
  {
    this._callback = cb;
    return this;
  }

  callback()
  {
    if ( ! this._callback )
    {
      return;
    }

    this._callback();
  }

  static createInspectorField( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, parent:Element )
  {
    info.creator.addField( parentInfo, info, new CallbackButtonField(), parent ); 
  }
}


